export enum ELangCode {
  EN = "en",
  ZHS = "zhs",
  ZHT = "zht",
}
